// Transport failures (DNS, TLS, offline, timeout) as reported by expo/fetch on iOS/Android
// and by browsers on web. These mean the request never got an answer from the API.
const NETWORK_ERROR_PATTERNS = [
  /fetch failed/i,
  /network request failed/i,
  /failed to fetch/i,
  /load failed/i,
  /hostname could not be found/i,
  /could not connect to the server/i,
  /internet connection appears to be offline/i,
  /network connection was lost/i,
  /tls error/i,
  /secure connection/i,
  /timed out/i,
];

export const CONNECTION_ERROR_MESSAGE =
  "Can't reach PCKM right now. Check your connection, or turn off any VPN or DNS filter, then try again.";

export function isNetworkError(error: unknown): boolean {
  if (!error) {
    return false;
  }
  if (typeof error === 'object' && (error as { code?: unknown }).code === 'ETIMEDOUT') {
    return true;
  }
  const message =
    typeof error === 'string' ? error : (error as { message?: unknown }).message;
  return typeof message === 'string' && NETWORK_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}

export function getUserFacingErrorMessage(error: unknown, fallback: string): string {
  if (isNetworkError(error)) {
    return CONNECTION_ERROR_MESSAGE;
  }
  return error instanceof Error && error.message ? error.message : fallback;
}
